<template>
<div class="column col full-height full-width">
  <div style="flex:0 0 65px;">
    <div class="text-h6">테스트</div>
    <div>판독 영역이 설정된 템플릿/모델에 대한 테스트, 결과 확인 및 다운로드 가능합니다.</div>
  </div>
  <div class="column col full-height full-width" style="flex-wrap:nowrap">
    <card-layout style="flex:0 0 100px;">
      <template v-slot:header>
        <div>
          <span class="text-primary text-weight-bolder" style="margin-right:5px;">테스트 조건</span>
          <q-btn dense flat icon="help_outline" @click="state.dialogHelp = true" size="xs" />
          <q-btn color="primary" unelevated dense label="템플릿판독" disable size="sm" style="margin-left:15px" />
        </div>
      </template>
      <template v-slot:body>
        <div>테스트 데이터</div>
        <div style="flex:0 0 20px;" />
        <div style="flex:0 0 250px;">
          <q-file outlined color="teal" v-model="state.testFiles" label="이미지 파일을 업로드해주세요." dense size="sm" accept="image/*" class="ellipsis">
            <template v-slot:prepend>
              <q-icon name="cloud_upload" />
            </template>
          </q-file>
        </div>
        
        <div style="flex:0 0 20px;" />
        <q-select outlined v-model="state.template.value" :options="state.template.options" dense options-dense label="템플릿" style="min-width:100px;" />

        <div style="flex:0 0 20px;" />
        <q-btn unelevated color="primary" icon="manage_search" label="테스트" size="md" @click="test" />
      </template>
    </card-layout>

    <div style="flex:0 0 15px;" />
    <card-layout class="col full-height full-width" :styles="{paddingBody: '0px 0px'}">
      <template v-slot:header>
        <span class="text-primary text-weight-bolder" style="margin-right:5px;">테스트 결과</span>
        <span class="text-caption text-grey" style="margin-left:10px;">{{ state.testDate }}</span>
      </template>
      <template v-slot:body>
        <div v-if="templateData != undefined" class="row col full-height full-width">
          <div class="column col full-height full-width" style="padding:20px 20px;">
            <image-view ref="image-view" class="column col full-height full-width" style="border:1px solid rgb(224, 224, 224)"
              :template-data="templateData"
              :left-mouse-mode="state.leftMouseMode"
              :draw-label-text="state.drawLabelText"
              :draw-predicted-text="state.drawPredictedText"
              @onframestatechange="listen__image_view__onframestatechange"
            />
          </div>
          <div class="column col full-height full-width" style="border-left:1px solid rgb(224, 224, 224);max-width:450px;">
            <div style="flex:0 0 15px" />
            <div class="column" style="padding:0px 10px;">
              <div>
                <span class="text-weight-bold">도구</span>
                <q-btn dense flat icon="help_outline" @click="state.dialogTool = true" size="xs" />
              </div>
              <div style="flex:0 0 5px;" />
              <div class="column" style="padding:0px 15px;">
                <div class="row" style="align-items:center;">
                  <span class="text-caption text-grey-8">인식결과 다운로드</span>
                  <select v-model="state.outputFormat.value" style="margin-left:10px;">
                    <option v-for="(option, index) in state.outputFormat.options"  :value="option" :key="`${index}`" :disabled="option != 'JSON'">{{option}}</option>
                  </select>
                  <q-btn unelevated dense color="primary" icon="download" size="sm" style="margin-left:10px;" @click="listen__template__ondownload()" />
                </div>
                <div class="row" style="align-items:center;">
                  <span class="text-caption text-grey-8">이미지 배율</span>
                  <q-btn unelevated icon="fit_screen" color="primary" label="창에 맞게" dense size="sm" style="margin-left:44px;" @click="$refs['image-view'].fitToWindow()" />
                  <q-slider
                    class="col"
                    :value="state.imageScale.value"
                    @change="listen__imageScale__onchange"
                    :min="state.imageScale.min"
                    :max="state.imageScale.max"
                    :step="5"
                    color="primary"
                    style="margin:0px 15px;"
                    label
                  />
                </div>
                <div style="flex:0 0 2px;" />
                <div class="row">
                  <span class="text-caption text-grey-8">필드 이름 표시</span>
                  <q-toggle v-model="state.drawLabelText" color="primary" dense style="margin-left:29px;" />
                </div>
                <div style="flex:0 0 12px;" />
                <div class="row">
                  <span class="text-caption text-grey-8">필드 정답 표시</span>
                  <q-toggle v-model="state.drawPredictedText" color="primary" dense style="margin-left:28px;" />
                </div>
                <div style="flex:0 0 12px;" />
                <div class="row">
                  <span class="text-caption text-grey-8">필드 목록 펼치기</span>
                  <q-toggle v-model="state.fieldListUnfold" color="primary" dense style="margin-left:17px;" />
                </div>
              </div>
            </div>
            <div style="flex:0 0 15px" />
            <div class="column col full-width" style="padding:0px 10px;">
              <div class="row full-width">
                <span class="text-weight-bold">판독 필드 
                  <span v-if="state.fieldListFilter == ''" class="text-caption">{{ `( ${fields.length}개 )` }}</span>
                  <span v-else class="text-caption">{{ `( ${searchFields.length} / ${fields.length}개 )` }}</span>
                </span>
                <q-space />
                <div class="row" style="align-items:center;">
                  <q-icon name="search" />
                  <input class="text-primary" ref="field-list-search" placeholder="Search..." style="width:80px;font-size:12px;border:none;" @input="listen__fieldList__onsearch" />
                  <q-icon name="close" style="cursor:pointer" @click="listen__fieldList__onsearchclear" />
                </div>
              </div>
              <q-separator />
              <div v-if="searchFields.length == 0" class="column col" style="align-items:center;justify-content:center;">
                <q-icon name="warning" class="text-grey q-pa-sm" size="md" />
                <div class="text-grey" >{{`필드 이름에 "${state.fieldListFilter}"이 포함된 필드가 없습니다.`}}</div>
              </div>
              <div v-else class="column col full-width" style="overflow-y:auto;">
                <q-list ref="field-list" class="full-width">
                  <template v-for="(field, index) in searchFields">
                    <field-list-item
                      :mode="'test'"
                      :field="field"
                      :key="`field-${index}`"
                      :unfold="state.fieldListUnfold === true"
                      @ontoggle="listen__fieldItem__ontoggle"
                      @onfocus="listen__fieldItem__onfocus"
                    />
                    <q-separator v-if="index < searchFields.length - 1" :key="`sep-${index}`" />
                  </template>
                </q-list>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="column col full-height">
          <div class="text-grey" style="flex:1 0 0;display:flex;flex-direction:column;justify-content:center;align-items:center;">
            <q-icon name="warning" class="text-grey q-pa-sm" size="md" />
            <div>[<q-icon name="manage_search" size="xs" /> 테스트]를 클릭하여 테스트를 진행해 주세요.</div>
          </div>
        </div>
      </template>
    </card-layout>
  </div>

  <q-dialog v-model="state.dialogHelp">
    <q-card>
      <q-card-section>
        <div class="text-h6">테스트 조건</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum repellendus sit voluptate voluptas eveniet porro. Rerum blanditiis perferendis totam, ea at omnis vel numquam exercitationem aut, natus minima, porro labore.
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>
  <q-dialog v-model="state.dialogTool">
    <q-card>
      <q-card-section>
        <div class="text-h6">도구</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum repellendus sit voluptate voluptas eveniet porro. Rerum blanditiis perferendis totam, ea at omnis vel numquam exercitationem aut, natus minima, porro labore.
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>

  <q-inner-loading :showing="state.loadingLayer.show">
    <q-spinner-facebook
        color="primary"
        size="2em"
      />
    {{state.loadingLayer.message}}
  </q-inner-loading>
</div>
</template>

<script>
import FieldListItem from '@/projects/template_ocr/components/FieldListItem.vue'
import CardLayout from '@/projects/template_ocr/components/CardLayout.vue'
import ImageView from '@/projects/template_ocr/views/ImageView.vue'

import lodash from 'lodash'

import COMM from '@/js/comm.js'
import PARSE from '@/js/parse.js'
import MISC from '@/js/miscellaneous.js'
import TEMPLATE from '@/js/template.js'

export default {
  components: {
    CardLayout,
    ImageView,
    FieldListItem
  },
  data: function () {
    return {
      state: {
        dialogHelp: false,
        dialogTool: false,
        loadingLayer: {
          show: false,
          message: ''
        },
        template: {
          value: '',
          options: []
        },
        outputFormat: {
          value: 'JSON',
          options: ['JSON', 'PNG']
        },
        testFiles: [],
        refreshTime: 'null',
        leftMouseMode: 'pan',
        imageScale: {
          min: 20,
          max: 300,
          value: 100
        },
        drawLabelText: true,
        drawPredictedText: true,
        fieldListUnfold: false,
        testDate: '',
        fieldListFilter: ''
      },
      templatesPairNameId: {},
      templateData: undefined,
      fields: []
    }
  },
  methods: {
    listen__imageScale__onchange(val) {
      this.state.imageScale.value = val
      this.$refs['image-view'].zoom(val / 100)
    },
    listen__image_view__onframestatechange: function (e) {
      this.state.imageScale.value = parseInt(e.zoom * 100);
    },
    listen__template__ondownload: async function () {
      this.$q.notify({message: `인식 결과를 다운로드 합니다. 잠시만 기다려 주세요.`, icon: 'info', color: 'black'})
      let fileName
      if (this.state.testFiles instanceof File)
        fileName = `${this.state.testFiles.name.split('.')[0]}.json`
      else
        fileName = 'result.json'
      this.download(fileName, JSON.stringify(this.templateData.template, null, 2))
    },
    listen__fieldItem__ontoggle: function () {
      let cnt = 0
      let cntUnfold = 0
      for (let vel of this.$refs['field-list'].$children) {
        if (vel.state != undefined) {
          cnt += 1
          cntUnfold = cntUnfold + (vel.state.unfold ? 1 : 0)
        }
      }
      if (cntUnfold == cnt)
        this.state.fieldListUnfold = true
      else if (cntUnfold == 0)
        this.state.fieldListUnfold = false
      else
        this.state.fieldListUnfold = 'intermediate'
    },
    listen__fieldItem__onfocus: function (rect) {
      this.$refs['image-view'].move(rect)
    },
    listen__fieldList__onsearch: lodash.debounce(function () {
      this.state.fieldListFilter = this.$refs['field-list-search'].value
    }, 300),
    listen__fieldList__onsearchclear: function () {
      this.state.fieldListFilter = ''
      this.$refs['field-list-search'].value = ''
    },
    refresh: async function () {
      this.state.loadingLayer = {
        show: true,
        message: '템플릿을 불러오는 중 입니다.'
      }
      let templates;
      try {
        let ret = await COMM.getTemplate();
        templates = ret.data
      } catch {
        this.$q.notify({
          message: '템플릿을 불러오지 못했습니다.',
          icon: 'announcement',
          color: 'red'
        })
        this.state.loadingLayer = {
          show: false,
          message: ''
        }
        return;
      }
      
      let templatesPairNameId = {}
      for (let row of templates)
        templatesPairNameId[row.templateName] = row.templateId
      this.templatesPairNameId = templatesPairNameId
      this.state.template.options = Object.keys(templatesPairNameId)
      if (Object.keys(templatesPairNameId).length > 0 && (this.state.template.value == '' || templatesPairNameId[this.state.template.value] == undefined))
        this.state.template.value = Object.keys(templatesPairNameId)[0]
      this.state.loadingLayer = {
        show: false,
        message: ''
      }
      this.state.refreshTime = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().split('.')[0].replace('T', ' ')
    },
    test: async function () {
      this.templateData = undefined
      if ((this.state.testFiles instanceof File) == false) {
        this.$q.notify({
          message: '이미지 파일을 업로드해 주세요.',
          icon: 'announcement',
          color: 'purple'
        })
        return
      }

      if (this.state.template.value == '') {
        this.$q.notify({
          message: '템플릿을 선택해 주세요.',
          icon: 'announcement',
          color: 'purple'
        })
        return
      }

      this.state.loadingLayer = {
        show: true,
        message: '템플릿을 불러오는 중 입니다.'
      }
      
      let template
      let layouts
      try {
        const ret = await COMM.getTemplate(this.templatesPairNameId[this.state.template.value]);
        template = ret.data
        const fieldColors = this.$store.state.constant.fieldColors
        for (let idx in template.fields) {
          let field = template.fields[idx]
          field.id = MISC.getUuid4()
          field.color = fieldColors[idx % fieldColors.length]
        }
        layouts = template.fields.map(v => TEMPLATE.fieldToLayout(v))
      } catch {
        this.$q.notify({
          message: '템플릿을 불러오지 못했습니다.',
          icon: 'announcement',
          color: 'red'
        })
        this.state.loadingLayer = {
          show: false,
          message: ''
        }
        return;
      }

      this.state.loadingLayer = {
        show: true,
        message: '인식 요청 중 입니다.'
      }
      let candidates
      try {
        candidates = await COMM.templateRecognize(this.state.testFiles, layouts)
      } catch {
        this.$q.notify({
          message: '인식서버에서 오류가 발생하였습니다.',
          icon: 'announcement',
          color: 'red'
        })
        this.state.loadingLayer = {
          show: false,
          message: ''
        }
        return;
      }
      console.log(layouts)
      console.log(candidates)
      let imageData
      try {
        imageData = await PARSE.parseImage(this.state.testFiles, MISC.getFileExtension(this.state.testFiles.name))
      } catch (err) {
        this.$q.notify({
          message: '이미지 읽기에 실패하였습니다.',
          icon: 'announcement',
          color: 'purple'
        })
        this.state.loadingLayer = {
          show: false,
          message: ''
        }
        return;
      }

      for (let field of template.fields) {
        const idxs = MISC.arrayWhere(candidates.map(v => v.tname), field.name)
        let candidateStrings = []
        let candidatePoints = [100000, 100000, -100000, -100000]
        field.textLength = idxs.length
        for (let i in idxs) {
          const idx = idxs[i]
          if (i == 0)
            candidateStrings = candidates[idx].candidatestring.map(v => v.split('\t'))
          else {
            const candidateStrings1 = candidates[idx].candidatestring.map(v => v.split('\t'))
            for (let ic in candidateStrings) {
              if (ic >= candidateStrings1.length)
                break
              candidateStrings[ic][0] = `${candidateStrings[ic][0]} ${candidateStrings1[ic][0]}`
              candidateStrings[ic][1] = candidateStrings[ic][1] * candidateStrings1[ic][1]
            }
          }
          const candidatePoint = candidates[idx].candidatepoint
          candidatePoints[0] = Math.min(candidatePoints[0], candidatePoint[0])
          candidatePoints[1] = Math.min(candidatePoints[1], candidatePoint[1])
          candidatePoints[2] = Math.max(candidatePoints[2], candidatePoint[2])
          candidatePoints[3] = Math.max(candidatePoints[3], candidatePoint[3])
        }
        field.candidateStrings = candidateStrings
        if (candidateStrings.length > 0) {
          field.text = candidateStrings[0][0]
          field.probability = candidateStrings[0][1]
          field.candidatePoints = candidatePoints
        }
      }
      this.templateData = {
        template,
        imageData
      }
      this.state.testDate = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().split('.')[0].replace('T', ' ')
      this.fields = template.fields
      this.state.loadingLayer = {
        show: false,
        message: ''
      }
    },
    download: function (filename, text) {
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    }
  },
  computed: {
    searchFields: function () {
      let ret = []
      const filter = this.state.fieldListFilter
      for (let field of this.fields) {
        if (field.name.indexOf(filter) != -1)
          ret.push(field)
      }
      return ret
    }
  },
  watch: {
    'state.testFiles': function () {
      this.templateData = undefined
    },
    'state.template.value': function () {
      this.templateData = undefined
    },
    templateData: function (value) {
      if (value == undefined)
        this.state.testDate = ''
    },
    'searchFields': function (searchFields) {
      const ids = searchFields.map(v => v.id)
      if (this.$refs['image-view'] != undefined)
        this.$refs['image-view'].setVisibleAnnotation(ids)
    }
  },
  mounted () {
    this.refresh()
  }
}
</script>

<style scoped>
.card-title {
  flex:0 0 40px;
  display:flex;
  flex-direction:row;
  padding:0px 20px;
  align-items:center;
}
</style>